<mat-form-field appearance="outline" class="mb-0">
    <input matInput 
        class="custom-datepicker-input" 
        [matDatepicker]="picker" 
        [placeholder]="placeholder"
        [disabled]="true"
        [(ngModel)]="selectedDate"
        (ngModelChange)="changeDate($event, picker)"
    >
    <mat-datepicker-toggle class="custom-datepicker-toggle" matIconSuffix [for]="picker">
        <mat-icon matDatepickerToggleIcon [svgIcon]="icon"></mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker [disabled]="disabled" (viewChanged)="clearFocus(); addAdditionalBlockToCalendar()" 
        (opened)="pickerOpen()" (closed)="pickerClose()"></mat-datepicker>
</mat-form-field>